import { ref, computed } from 'vue';

// 获取翻译函数
const getT = () => {
  return window.__VUE_I18N__?.global?.t || ((key) => key);
};

// Singleton state
const user = ref(null);
const error = ref(null);
const loading = ref(false);

export function useAuth() {

  const setUser = (obj) => {
    user.value = obj;
  };

  const fetchUser = async () => {
    loading.value = true;
    error.value = null;
    try {
      const response = await fetch('/api/user', {
        credentials: 'include', // 包含cookie
        redirect: 'manual' // 手动处理重定向
      });

      if (response.type === 'opaqueredirect' || response.status === 302) {
        // 遇到重定向，说明需要登录，让浏览器处理重定向
        console.log('需要重定向到登录页面');
        // 不进行重定向，让调用方处理
        user.value = null;
        return;
      }

      if (!response.ok) {
        if (response.status === 401) {
          // This is an expected case if the user is not logged in via IAP
          user.value = null;
          console.log(getT()('composables.logs.userNotAuthenticated'));
        } else {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
      } else {
        const data = await response.json();
        user.value = data;
        console.log(getT()('composables.logs.userAuthenticated'), data);
      }
    } catch (e) {
      console.error('Failed to fetch user:', e);
      error.value = getT()('composables.errors.fetchUserFailed');
      user.value = null;
    } finally {
      loading.value = false;
    }
  };


  const isAuthenticated = computed(() => !!user.value);
  const isAdmin = computed(() => user.value?.role === 'admin');
  const isEditor = computed(() => user.value?.role === 'admin' || user.value?.role === 'editor');

  // 检查URL参数中的登录状态
  const checkLoginStatus = () => {
    const urlParams = new URLSearchParams(window.location.search);
    const loginStatus = urlParams.get('login');
    const error = urlParams.get('error');

    if (loginStatus === 'success') {
      console.log('登录成功！');
      // 清除URL参数
      window.history.replaceState({}, document.title, window.location.pathname);
      // 重新加载用户信息
      fetchUser();
    } else if (error) {
      console.error('登录失败:', error);
      // 清除URL参数
      window.history.replaceState({}, document.title, window.location.pathname);
    }
  };

  // Expose a single initialization function
  const initializeAuth = async () => {
    // 首先检查URL参数中的登录状态
    checkLoginStatus();

    if (!user.value) {
      await fetchUser();
    }
  };

  return {
    user: computed(() => user.value),
    setUser,
    isAuthenticated,
    loading: computed(() => loading.value),
    error: computed(() => error.value),
    initializeAuth,
    isAdmin,
    isEditor
  };
}
